
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';
import { WorkUseremploymentGavType } from '../models/work-useremployment-gav-type';
import { WorkUseremploymentSalaryIntervalEnum } from '../models/work-useremployment-salary-interval-enum';

export function getCreateUseremploymentDtoFormGroup() {
return new FormGroup({
    userId: new FormControl<number | undefined>(undefined, [Validators.required]),
    agentId: new FormControl<number | undefined>(undefined),
    businessdivisionId: new FormControl<number | undefined>(undefined),
    businessunitId: new FormControl<number | undefined>(undefined),
    type: new FormControl<string | undefined>('', [Validators.required]),
    workload: new FormControl<number | undefined>(100),
    targetHours: new FormControl<number | undefined>(undefined),
    validFrom: new FormControl<string | undefined>(undefined, [Validators.required]),
    validTo: new FormControl<string | undefined>(undefined, [Validators.required]),
    trialPeriodTo: new FormControl<string | undefined>(undefined),
    pricePerHour: new FormControl<number | undefined>(undefined),
    holidaysPerYear: new FormControl<number | undefined>(undefined),
    extEmployeenr: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    extAssignmentnr: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    extAgreementnr: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    jobtitle: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    mondayMorning: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    mondayAfternoon: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    tuesdayMorning: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    tuesdayAfternoon: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    wednesdayMorning: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    wednesdayAfternoon: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    thursdayMorning: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    thursdayAfternoon: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    fridayMorning: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    fridayAfternoon: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    saturdayMorning: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    saturdayAfternoon: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    sundayMorning: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    sundayAfternoon: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    expensesEntitled: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    wayExpensesEntitled: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    isPlannableInMontageplan: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    gavType: new FormControl<WorkUseremploymentGavType | undefined>(undefined),
    gavRegistered: new FormControl<string | undefined>(undefined),
    gavUnregistered: new FormControl<string | undefined>(undefined),
    gavEducationCompletedAs: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    gavEducationCompletedOn: new FormControl<string | undefined>(undefined),
    gavExperienceYears: new FormControl<number | undefined>(undefined),
    gavNotes: new FormControl<string | undefined>(undefined),
    supervisorId: new FormControl<number | undefined>(undefined),
    timeBlockTemplateId: new FormControl<number | undefined>(undefined),
    salaryGross: new FormControl<number | undefined>(undefined),
    salaryInterval: new FormControl<WorkUseremploymentSalaryIntervalEnum | undefined>(undefined),
})
;
}
      